// eslint-disable-next-line import/prefer-default-export
export const notDeliveryCategoriesIds = Object.freeze(new Set([26, 27, 33, 37, 40]));
